import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import { Base } from "../../components/RootLayout";
import { iconBack, iconSetting } from "../../utils/svg_assets";
import { useParams } from "react-router-dom";
import TopNavigation from "../../components/TopNavigation";

const SummaryInfo = (props) => {
  let { typeInfo } = useParams();

  const { pointInfo, starInfo, initInfo } = props;

  useEffect(() => {
    initInfo();
  }, []);

  return (
    <Base>
      <TopNavigation
        titlePage={typeInfo === "point" ? "Point Info" : "Level and Star Info"}
        toPath={-1}
        setBorder={false}
        showLeftIcon={true}
        showRightIcon={false}
        iconLeft={iconBack}
        iconRight={iconSetting}
        rightEvent={false}
      />
      <Container
        className="summary-star-info"
        dangerouslySetInnerHTML={{
          __html:
            typeInfo === "point"
              ? pointInfo.clean_description
              : starInfo.clean_description,
        }}
      />
    </Base>
  );
};

const mapStateToProps = (state) => ({
  pointInfo: state.FinanceSM.pointInfo,
  starInfo: state.FinanceSM.starInfo,
});

const mapDispatchToProps = (dispatch) => ({
  initInfo: dispatch.FinanceSM.initInfo,
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryInfo);
